import e30 from 'assets/productImages/E30.png';
import e50 from 'assets/productImages/E50.png';
import e70 from 'assets/productImages/E70.png';
import e90 from 'assets/productImages/E90.png';
import e120 from 'assets/productImages/E120.png';
import e190 from 'assets/productImages/E190.png';
import e250 from 'assets/productImages/E250.png';
import e310 from 'assets/productImages/E310.png';
import e400 from 'assets/productImages/E400.png';
import e550 from 'assets/productImages/E550.png';

import e30Cover from 'assets/pdf/E30.jpg';
import e50Cover from 'assets/pdf/E50.jpg';
import e70Cover from 'assets/pdf/E70.jpg';
import e90Cover from 'assets/pdf/E90.jpg';
import e120Cover from 'assets/pdf/E120.jpg';
import e190Cover from 'assets/pdf/E190.jpg';
import e250Cover from 'assets/pdf/E250.jpg';
import e310Cover from 'assets/pdf/E310.jpg';
import e400Cover from 'assets/pdf/E400.jpg';
import e550Cover from 'assets/pdf/E550.jpg';

export const productImages = {
	e30,
	e50,
	e70,
	e90,
	e120,
	e190,
	e250,
	e310,
	e400,
	e550,
}

export const pdfCoverImages = {
	e30: e30Cover,
	e50: e50Cover,
	e70: e70Cover,
	e90: e90Cover,
	e120: e120Cover,
	e190: e190Cover,
	e250: e250Cover,
	e310: e310Cover,
	e400: e400Cover,
	e550: e550Cover
}

export const getCoverImageForRecommendedSleipner = modelNumber => {
	return getImage(modelNumber, pdfCoverImages);
}

export const getModelImage = modelNumber => {
	return getImage(modelNumber, productImages);
}

const getImage = (modelNumber, images) => {

	if (!modelNumber) return images[Object.keys(images)[0]];

	const n = modelNumber.toLowerCase();
	const img = images[n];

	if (!img) return images.e70;

	return img;
}
